import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var RevertedItem = function (props) {
    var _a;
    var i18n = props.i18n, revertedCase = props.revertedCase;
    var author = revertedCase.author, previousStatus = revertedCase.previousStatus;
    var decapsulatedLabel = previousStatus.code // TODO FIX difference between V4 and V5, code is for V4
        ? "caseGlobalView.moStatus.".concat(previousStatus.code, ".label")
        : (_a = previousStatus.label) === null || _a === void 0 ? void 0 : _a.slice(3, previousStatus.label.length - 2);
    var previousLabel = getPropsByKeyPath(i18n.keyValueMap, decapsulatedLabel);
    var description = getPropsByKeyPath(i18n, 'modules.timeline.revertedCase.textAction')
        .replace('$username ', '')
        .replace('$previousStatus', '');
    var authorLabel = (author === null || author === void 0 ? void 0 : author.login) || getPropsByKeyPath(i18n, 'modules.timeline.defaultUser');
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [_jsx("b", { children: authorLabel }), " ", description, " ", _jsx("b", { children: previousLabel })] }) }));
};
